import { createElementBlock as t, openBlock as a, createElementVNode as e } from "vue";
import o from "./index289.js";
const r = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function m(c, l, s, p, v, Z) {
  return a(), t("svg", n, l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "M17 2.25a1.75 1.75 0 0 1 1.744 1.607L18.75 4v3.287l2.428 2.207c.369.335.557.783.572 1.233v9.248c0 .927-.704 1.695-1.606 1.77L20 21.75H4a1.76 1.76 0 0 1-1.744-1.63l-.006-.145V10.75l.002-.04c.017-.396.167-.79.456-1.105l.107-.108L5.25 7.253V4a1.75 1.75 0 0 1 1.607-1.744L7 2.25h10ZM8.865 16.195 4.81 20.25h14.379l-4.052-4.052-1.59 1.078a2.754 2.754 0 0 1-2.92.105l-.167-.105-1.595-1.081Zm11.385-3.463-3.848 2.609 3.848 3.848v-6.457Zm-16.5-.003v6.459l3.85-3.85-3.85-2.609ZM17 3.75H7a.25.25 0 0 0-.243.193L6.75 4v8.95l4.551 3.084c.386.26.881.285 1.287.071l.118-.07 2.084-1.413.01-.006 2.45-1.662V4a.25.25 0 0 0-.193-.243L17 3.75Zm-3.364 8.318a.75.75 0 0 1 .102 1.493l-.102.007H8.727a.75.75 0 0 1-.101-1.493l.101-.007h4.91Zm5.114-2.754v2.624l1.391-.943a.25.25 0 0 0 .072-.34l-.043-.051-1.42-1.29Zm-13.5-.021L3.831 10.6a.25.25 0 0 0-.02.347l.049.044 1.39.942v-2.64Zm10.023-.498a.75.75 0 0 1 .101 1.494l-.101.006H8.727a.75.75 0 0 1-.101-1.493l.101-.007h6.546Zm0-3.272a.75.75 0 0 1 .101 1.493l-.101.007H8.727a.75.75 0 0 1-.101-1.493l.101-.007h6.546Z"
    }, null, -1)
  ]));
}
const _ = /* @__PURE__ */ o(r, [["render", m]]);
export {
  _ as default
};
